{
  "aiCritiqueWorkingAlready": "Ya funciona",
  "aiCritiqueDoThisNext": "Haz esto ahora",
  "aiCritiqueStillMissing": "Todavía falta",
  "aiCritiqueEveryoneElse": "Los demás, en una línea",
  "aiCritiqueRead": "Leer →",
  "SectionsLeft": "secciones restantes",
  "NextUpYourAnswer": "Siguiente: tu respuesta",
  "NextUp": "Siguiente: {{name}}",
  "PreviousSection": "Sección anterior",
  "YourAnswer": "Tu respuesta",
  "ThisBuilder": "Este builder",
  "Builder": "Builder",
  "of": "de",
  "Intro": "Introducción",
  "SkipToAnswer": "Ir a la respuesta →",
  "BuilderProgress": "Progreso del builder",
  "SectionsRead": "secciones leídas",
  "AnswerSaved": "guardada",
  "AnswerInProgress": "en curso",
  "OnTrack": "Sección actual: ",
  "InGroup": "En Groupo: ",
  "switchTracks": "Cambiar secciones",
  "switchTracksOrGroup": "Cambiar de track o grupo",
  "Progress": "Progreso",
  "selectTrack": "Seleccionar sección",
  "selectTracksOrGroup": "Seleccionar track o grupo",
  "Builders": "Builders",
  "JumpBackIn": "Salta hacia atrás ...",
  "NoTrackSelected": "Sin seccion selecionada",
  "tracks": "secciones",
  "subject": "Tema",
  "seeAllBuilders": "Ver todos los builders",
  "IntroTo": "Introducción a ",
  "next": "Siguiente ",
  "BackToBuilder": "Regresar a la Visión General del Builder",
  "OverviewOf": "Descripción general del ",
  "steps": "pasos",
  "Introduction": "Introducción",
  "Answer": "Responder",
  "Revisit": "Revisar",
  "Go": "Ir >",
  "outOf1step": "de 1 paso",
  "outOf1steps": "de 1 pasos",
  "outOf": "de ",
  "completed": "Completado",
  "Review+Publish": "Revisar + Publicar",
  "GoToReview+Publish": "Ir a revisar + Publicar",
  "NoAnswer": "Todavia sin respuesta",
  "backToTopics": "Volver a temas",
  "ConfirmLeavingPage": "¿Estás seguro de que quieres salir de esta página sin guardar?",
  "ConfirmLeavingAnswerPage": "¿Está seguro de que quiere salir de esta página? ¡Cualquier trabajo que no se haya guardado se perderá!",
  "ProfilePreview": "Revisión: vista previa del perfil",
  "done": "Hecho",
  "Published": "Publicado",
  "editPublishSettings": "Editar la configuración de publicación",
  "VisibleTo": "Visible para",
  "PublishSettings": "Publicar configuración",
  "Publish": "Publicar",
  "ControlProfileAccess": "Controla quién puede ver esto en el perfil de tu proyecto",
  "selectVisibility": "Selecciona una visibilidad",
  "VisibilityOpt1": "Cualquier persona",
  "VisibilityOpt2": "Mi hub, grupos, eventos",
  "VisibilityOpt3": "Mis eventos",
  "VisibilityOpt4": "Solo equipo",
  "VisibilityDetails": "? Detalles de visibilidad",
  "VisibilityDetailsPart1": "Cualquiera que vea tu perfil puede ver esto",
  "VisibilityDetailsPart2": "Cualquier persona que sea miembro de un hub al que pertenece o cualquier persona que asista a un evento en el que está compitiendo puede ver esta información en tu perfil",
  "VisibilityDetailsPart3": "Cualquiera que asista a un evento en el que estás compitiendo puede ver esta información en tu perfil",
  "VisibilityDetailsPart4": "Solo tu equipo (incluidos los miembros de tu equipo de soporte) puede ver esta información en tu perfil",
  "ViewOnProjectPage": "Ver en la página del proyecto",
  "HeadsUp": "Aviso",
  "LastUpdated": "Última actualización ",
  "by": "por",
  "save": "Guardar",
  "back": "Atras",
  "finish": "Terminar",
  "someoneElseWorking1": "estás trabajando en esta pregunta. Puedes editar una vez que hayas terminado.",
  "someoneElseWorking2": " también estás trabajando en este builder.",
  "Step1Intro": "Paso 1 - Introducción",
  "Step": "Paso ",
  "backToBuilders": "Volver a todos los builders",
  "skipToAnswer": "Saltar para responder",
  "GotItNext": "Lo tengo, siguiente",
  "NoGoBack": "No, vuelve",
  "YesClose": "Si, cerrar",
  "addedToTheGroupHeader": "Fuiste agregado al grupo:",
  "addedToTheGroupMessage": "también se agregó automáticamente.",
  "addedToTheGroupHint": "Sugerencia: puedes cambiar tu proyecto en cualquier momento en la página del grupo.",
  "firstChoice": "¡Okay!",
  "DoNotAddProject": "No agregues un proyecto",
  "SecondChoice": "Cambiar a otro proyecto",
  "LockedTopicTitle": "Debes ser parte de un hub para ver este contenido.",
  "LockedTopicPhrasePart1": "Ponte en contacto con tu universidad o empresa para ver si patrocinarán tu comunidad. O puedes",
  "ContactUs": "contactar con nosotros",
  "LockedTopicPhrasePart2": "para cualquier pregunta.",
  "ReadMore": "Leer más…",
  "DifficultyLevel": "Nivel de dificultad:",
  "SeeGroupPage": "ver la página del grupo",
  "NoScheduleYet": "Aún no se ha establecido un horario para este grupo.",
  "FaciliationTools": "Herramientas de facilitación",
  "FaciliationTools1": "Guía de lanzamiento del Hub",
  "FaciliationTools2": "El plan de estudios de RebelBase, builders y hub",
  "FaciliationTools3": "Esquema de Builders",
  "PastDue": "vencido",
  "NextTrack": "Siguiente seccioón >>",
  "OpenAs": "Abierto como",
  "editTopic": "editar tema",
  "rebelMapMinimize": "minimizar",
  "rebelMapUnminimize": "restaurar",
  "rebelMapExpand": "ampliar",
  "rebelMapShrink": "reducir",
  "rebelMapMoveLeft": "mover a la izquierda",
  "rebelMapMoveRight": "mover a la derecha",
  "rebelMapPdf": "pdf",
  "rebelMapInteractiveFile": "archivo interactivo",
  "aiCritiqueTitle": "Panel de crítica",
  "aiCritiqueAnalyze": "Analizar",
  "aiCritiqueReanalyze": "Reanalizar",
  "aiCritiqueReviewing": "Revisando…",
  "aiCritiqueNoFeedback": "Este revisor no devolvió comentarios en esta ejecución — prueba Re-analizar.",
  "aiCritiqueSpecialistCount": "{{count}} perspectivas de especialistas",
  "aiCritiqueSubtitle": "Un panel de especialistas lee tu respuesta y opina",
  "aiCritiquePromptEmpty": "Agrega tu respuesta arriba para ejecutar la crítica.",
  "aiCritiquePromptReady": "Haz clic en Analizar para recibir comentarios de IA sobre tu respuesta de un panel de especialistas.",
  "aiCritiqueReviewingAcross": "Revisando desde {{count}} perspectivas de especialistas…",
  "aiCritiqueTryAgain": "Intentar de nuevo",
  "aiCritiqueDismiss": "Descartar",
  "aiCritiqueErrorBody": "El análisis se agotó y no pudo completarse. No se te cobró por esto: inténtalo de nuevo.",
  "aiCritiqueSomeone": "Un compañero",
  "aiCritiqueLockedAnalyzing": "{{who}} está analizando este tema: los resultados aparecerán para todo el equipo.",
  "aiCritiqueLockedEditing": "{{who}} está editando: Analizar está pausado hasta que termine.",
  "aiCritiqueLimitBody": "Has usado el presupuesto de Crítica de IA de hoy: se restablece a las 00:00 UTC.",
  "aiCritiqueTopicLimitBody": "Este tema ya ha usado sus {{count}} Críticas de IA de hoy. El límite es compartido con tu equipo y se restablece a las 00:00 UTC.",
  "aiCritiqueTopicLimitBodyGeneric": "Este tema ya ha usado sus Críticas de IA de hoy. El límite es compartido con tu equipo y se restablece a las 00:00 UTC.",
  "aiCritiqueTopicRemaining": "Quedan {{remaining}} de {{limit}} hoy",
  "aiCritiqueStaleBody": "El contenido cambió desde este análisis: reanaliza para obtener comentarios actualizados.",
  "aiCritiqueChampion": "Campeón",
  "aiCritiqueConfidence": "confianza {{level}}",
  "aiCritiqueKeyInsights": "Ideas clave",
  "aiCritiqueConcerns": "Inquietudes",
  "aiCritiqueRecommendations": "Recomendaciones",
  "aiCritiqueQuestions": "Preguntas para el equipo",
  "aiCritiqueInfoGaps": "Vacíos de información",
  "aiCritiqueStatusDone": "listo",
  "aiCritiqueStatusReviewing": "revisando",
  "aiCritiqueThanksHelpful": "Gracias, nos alegra que haya sido útil.",
  "aiCritiqueThanksFeedback": "Gracias por tus comentarios.",
  "aiCritiqueUseful": "¿Fue útil esta crítica?",
  "aiCritiqueHelpful": "Útil",
  "aiCritiqueNotHelpful": "No útil",
  "aiCritiqueWhatBetter": "¿Qué se podría mejorar? (opcional)",
  "aiCritiqueSkip": "Omitir",
  "aiCritiqueSendFeedback": "Enviar comentarios",
  "aiCritiqueLockedBusy": "En pausa mientras un compañero trabaja en este tema.",
  "Copyright": "Copyright © {{year}} RebelBase, Inc. Todos los derechos reservados.",
  "Project": "Proyecto",
  "TopicProgress": "Progreso del tema",
  "Section": "Sección",
  "ThisTopic": "Este tema",
  "aiCritiqueRun": "Ejecutar crítica de IA",
  "aiCritiqueRerun": "Volver a ejecutar la crítica",
  "aiCritiqueEmptyTitle": "Un panel de especialistas, una lectura de tu respuesta",
  "aiCritiqueEmptyReady": "Ejecuta la crítica cuando estés listo. Cada especialista señala preocupaciones, plantea las preguntas que tu equipo debería responder y nombra lo que todavía falta.",
  "aiCritiqueIssuesToFix": "Problemas por corregir",
  "aiCritiqueCriticalCount": "{{count}} crítico",
  "aiCritiqueHighCount": "{{count}} alto",
  "aiCritiqueMediumCount": "{{count}} medio",
  "aiCritiqueNitsCount": "{{count}} menor",
  "aiCritiqueNitsCount_plural": "{{count}} menores",
  "aiCritiqueSpecialistPerspectives": "Perspectivas de especialistas",
  "aiCritiqueFinish": "Finalizar"
}